import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import Spinner from '../components/Spinner/Spinner';

const WithUserData = OriginalComponent => {
  return function WrapperComponent(props) {
    if (props.loading) {
      return <Spinner />;
    } else if (
      props.match.path.indexOf('proposals') !== -1 &&
      props.user.company.companyType !== 'retail'
    ) {
      return <Redirect to="/" />;
    } else if (props.roles && !props.roles.includes(props.user.role)) {
      return <Redirect to="/" />;
    } else {
      return <OriginalComponent {...props} />;
    }
  };
};

const mapStateToProps = state => ({
  loading: state.UIState.loading,
  user: state.AppState.user,
});

export default compose(
  connect(mapStateToProps),
  WithUserData,
);
